export default __webpack_public_path__ + "static/media/tunisia-logo.847bc2a7.svg";